<template>
  <div>
    <label for="coinType" class="text-gray-900">{{ $t('bitcoin_note').tTitle() }}</label>

    <div class="mt-2 mb-5">
      <!-- <p class="control">
        <span class="select-box">
          <span class="select">
            <select v-validate="'required'" name="coinType" v-model="coinType" :data-vv-as="$t('cryptocurrency')"
              class="bg-white font-semibold rtl:bg-left" :class="{ 'is-danger': errors.has('coinAddress') }">
              !! If you update the following options list edit the cryptoMappedObject below !!

              <option disabled value="">{{ $t('cryptocurrency') }}</option>
              <option value="BITCOIN-BLOCKCHAIN-MAINNET-BTC">Bitcoin (Bitcoin Network)</option>
              <option value="ETHEREUM-BLOCKCHAIN-MAINNET-ETH">Ether (Ethereum Network ERC-20)</option>
              <option value="LITECOIN-BLOCKCHAIN-MAINNET-LTC">Litecoin (Litecoin Network)</option>
              !!<option value="SOLANA-BLOCKCHAIN-MAINNET-SOL">Sol (Solana Network)</option>!!
              <option value="ETHEREUM-BLOCKCHAIN-MAINNET-USDC">USDC (Ethereum Network ERC-20)</option>
              <option value="TRON-BLOCKCHAIN-MAINNET-USDT">USDT (Tron Network TRC-20)</option>
             !! <option value="TRON-BLOCKCHAIN-MAINNET-TRX">Tronix (Tron Network TRC-20)</option>!!
            </select>
          </span>
        </span>
        <span v-show="errors.has('coinType')" class="text-red text-xs pt-0.5">{{ errors.first('coinType') }}</span>
      </p> -->
      <Select
        :options="[
          { value: 'BITCOIN-BLOCKCHAIN-MAINNET-BTC', text: 'Bitcoin (Bitcoin Network)' },
          { value: 'ETHEREUM-BLOCKCHAIN-MAINNET-ETH', text: 'Ether (Ethereum Network ERC-20)' },
          { value: 'LITECOIN-BLOCKCHAIN-MAINNET-LTC', text: 'Litecoin (Litecoin Network)' },
          // { value: 'SOLANA-BLOCKCHAIN-MAINNET-SOL', text: 'Sol (Solana Network)' },
          { value: 'ETHEREUM-BLOCKCHAIN-MAINNET-USDC', text: 'USDC (Ethereum Network ERC-20)' },
          { value: 'TRON-BLOCKCHAIN-MAINNET-USDT', text: 'USDT (Tron Network TRC-20)' },
         // { value: 'TRON-BLOCKCHAIN-MAINNET-TRX', text: 'Tronix (Tron Network TRC-20)' },
        ]"
        v-model="coinType"
        :name="$t('cryptocurrency')"
        :placeholder="$t('cryptocurrency')"
        :mode="'primaryWhite'"
        :optionValue="'value'"
        :optionLabel="'text'"
        :rules="'required'"
      />
    </div>

    <label for="coinAddress" class="text-base text-gray-900 mb-2">{{ $t('crypto_network_address').tTitle() }}</label>
    <div v-if="coinType != 'LIGHTNING'" class="mt-2 mb-5">
      <p class="control">
        <input v-validate="'required'" :class="{ input: true, 'is-danger': errors.has('coinAddress') }"
          name="coinAddress" type="text" class="bg-white input"
          :data-vv-as="$t('cryptocurrency_address')" :placeholder="$t('cryptocurrency_address')"
          v-model="coinAddress" />
        <span v-show="errors.has('coinAddress')" class="text-red text-xs pt-0.5">{{ errors.first('coinAddress')
          }}</span>
      </p>
    </div>

    <div class="flex gap-5 items-end flex-col md:flex-row">
      <div class="grow flex flex-col w-full">
        <label for="OTP" class="mb-2">{{ $t('otp') }}</label>
        <div class="columns">
          <div class="column is-8">
            <input v-validate="'required'" :class="{ input: true, 'is-danger': errors.has('OTP') }" name="OTP"
              type="text" :data-vv-as="'OTP'" :placeholder="'OTP'" v-model="OTP"
              class="bg-white input" />
          </div>
        </div>
      </div>
      <div class="column is-4 mt-2">
        <Button mode="secondary" @click="generateOTP" customClasses="min-w-[160px] !h-12 !text-sm md:mt-6">
          {{$t("otp_send_email").tTitle()}}
        </Button>
      </div>
    </div>
    <span v-show="errors.has('OTP')" class="text-red text-xs pt-0.5">{{ errors.first('OTP') }}</span>
    <div class="flex gap-5 mt-7 items-start flex-col md:flex-row">
      <div class="w-full md:w-auto">
        <label for="currency" class="text-base text-gray-900">{{ $t('currency').tTitle() }}</label>
        <div class="mt-2">
          <div class="bg-white py-3 w-full md:w-44 text-gray-900 text-base font-semibold ltr:pl-5 rtl:pr-5 rounded-md">
            {{ User.wallet.currency }}</div>
        </div>
      </div>
      <div class="grow w-full md:w-auto">
        <label for="amount" class="text-base text-gray-900">{{ $t('amount').tTitle() }}</label>
        <input v-validate="'required|currency|min_value:15|max_value:50000'"
          :class="{ input: true, 'is-danger': errors.has('amount') }" name="amount" type="text"
          :data-vv-as="translations.text.amount" :placeholder="0"
          v-model="amount" class="mt-2 bg-white" />
        <span v-show="errors.has('amount')" class="text-red text-xs pt-0.5"
          :class="{ 'text-right': Language == 'fa' }">{{
          amount >= 50000 ? $t('withdrawal_confirmo_amount_error') : errors.first('amount')
          }}</span>
      </div>
    </div>

    <div class="mt-5 mb-10">
      <p class="text-gray-900 text-base">{{ $t('popular_withdrawals') }}</p>
      <div class="flex mt-2 gap-1 md:gap-2 flex-wrap xl:flex-nowrap">
        <div v-for="item in popularWithdrawals" :key="item" @click="
            selectedPopularWithdrawal = item
            amount = item
          "
          class="w-[100px] xl:w-1/6 shrink-0 xl:shrink py-3 text-gray-900 text-base font-semibold rounded-md text-center bg-white border border-solid cursor-pointer focus:border-0 focus:outline-none focus:ring-0"
          :class="[selectedPopularWithdrawal == item ? 'border-green' : 'border-white']">
          {{ currencySymbols[User.wallet.currency].symbol + item }}
        </div>
      </div>
    </div>

    <Button mode="dark" @click="withdraw" customClasses="!w-52 mb-10">
      {{$t("withdraw").tTitle()}}
    </Button>
    <!-- <p class="text-sm text-gray-900 mb-10">{{ $t('provider_redirect', { provider: 'Confirmo'}) }}</p> -->
  </div>
</template>

<script>
// import {service} from '../../../main.js'
import config from '../../../config'
import { mapActions, mapGetters } from 'vuex'
import { service } from '../../../main.js'
import Button from '@/components/reusableComponents/Button.vue'
import Select from '@/components/reusableComponents/Select.vue'

export default {
  components: { Button ,Select},
  data() {
    return {
      amount: '',
      coinType: '',
      coinAddress: '',
      otpBtnEnabled: true,
      OTP: '',
      translations: {
        text: {
          amount: this.$t('amount'),
          coinAddress: this.$t('your_cryptocurrency_address'),
        },
      },
      currencySymbols: config.currencies,
      selectedPopularWithdrawal: '',
      popularWithdrawals: ['50', '75', '250', '500', '1000', '5000'],
      cryptoMappedObject: {
        'BITCOIN-BLOCKCHAIN-MAINNET-BTC': 'Bitcoin',
        'ETHEREUM-BLOCKCHAIN-MAINNET-ETH': 'Ether',
        'LITECOIN-BLOCKCHAIN-MAINNET-LTC': 'Litecoin',
        'ETHEREUM-BLOCKCHAIN-MAINNET-USDC': 'USDC',
        'TRON-BLOCKCHAIN-MAINNET-USDT': 'USDT',
      },
    }
  },
  watch: {
    // watcher for the i18n language change
    '$i18n.locale'() {
      this.$validator.reset()
    },
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
    }),
  },
  mounted() {},
  methods: {
    withdraw() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$bus.$emit('RequestWithdraw', '/finance/withdraw', {
            amount: String(this.amount),
            userID: this.$store.state.user.info.ID,
            psp: 'confirmo',
            extraInfo: JSON.stringify({ coinType: this.coinType, coinAddress: this.coinAddress }),
            OTP: this.OTP,
          })
        }
      })
    },
    generateOTP() {
      service
        .post('/finance/generate-otp', {
          userID: this.$store.state.user.info.ID,
          additionalText: this.$t('otp_additional_text', { coin: this.cryptoMappedObject[this.coinType] }),
        })
        .then(response => {
          if (response.data.success) {
            this.$toasted.success(this.$t('otp_new_password'))
          } else {
            this.$toasted.error(this.$t('otp_error'))
          }
        })
        .catch(error => {
          this.$toasted.error(this.$t('otp_error') + error)
        })
      this.otpBtnEnabled = false
      setTimeout(
        function () {
          this.otpBtnEnabled = true
        }.bind(this),
        15000
      )
    },
    ...mapActions(['logoLoader/set']),
  },
}
</script>
